import type { QueryClient } from "@tanstack/react-query";
import { getApprovedTimeEntries } from "@/lib/services/payrollService";
import { getTimeClockEntries } from "@/lib/services/timeClockService";
import { QueryKeys } from "@/lib/types";
import { TimeClockApi } from "@/openapi/generated";
import { createAuthenticatedApi } from "@/lib/utils";

/** Server prefetch for teacher/staff on `/admin/dashboard/time-clock`. */
export async function prefetchTeacherTimeClock(
  queryClient: QueryClient,
  userId: number,
  accessToken: string,
) {
  await Promise.allSettled([
    queryClient.prefetchQuery({
      queryKey: [QueryKeys.TimeClockEntries, userId],
      queryFn: () => getTimeClockEntries(accessToken, userId),
    }),
    queryClient.prefetchQuery({
      queryKey: [QueryKeys.PayrollHours, userId],
      queryFn: () => getApprovedTimeEntries(accessToken, userId),
    }),
    queryClient.prefetchQuery({
      queryKey: [QueryKeys.TimeEntryTypes],
      queryFn: async () => {
        const api = createAuthenticatedApi(TimeClockApi, accessToken);
        return api.apiTimeEntriesTypesGet({});
      },
      staleTime: 5 * 60 * 1000,
    }),
  ]);

  return queryClient;
}
